<template>
    <div class="item">
        <div class="head">
            <div class="name">
                <div class="quantity" v-if="option.quantity > 1">{{ option.quantity }}x</div>
                {{ getNameForCurrentUser(option) }}<ItemIcons :articleId="option.articleId" />
            </div>
            <div class="price">
                <CartItemPrice
                    v-if="option.unitPrice != 0"
                    class="cart-item-option-price"
                    :item="option"
                    :quantity="nextMultiplier"
                    @click="onPriceClick"
                />
            </div>
        </div>
        <div class="subs" v-if="option.options.length">
            <CartItemOptionGroup
                v-for="optionGroup in option.options"
                :key="optionGroup.id"
                :optionGroup="optionGroup"
                :multiplier="nextMultiplier"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { ICartItem } from "@/data/model/Customer";
    import { useCartStore } from "@/data/stores/cart";
    import { getNameForCurrentUser } from "@/shared/helpers/ItemNameHelper";
    import { computed } from "vue";

    import CartItemOptionGroup from "@/app/components/cart/CartItemOptionGroup.vue";
    import CartItemPrice from "@/components/cart/CartItemPrice.vue";
    import ItemIcons from "@/components/order/ItemIcons.vue";

    const cart = useCartStore();

    // define properties
    const props = defineProps<{
        option: ICartItem;
        multiplier: number;
    }>();

    // define computed
    const nextMultiplier = computed(() => props.multiplier * props.option.quantity);

    function onPriceClick() {
        if (!props.option.hasDiscount) {
            return;
        }

        cart.showConfirmItemDiscountsRemovalPopup(props.option);
    }
</script>

<style lang="scss">
    @use "./../../../../assets/styles/scss/shared/_variables.scss";

    // kiosk: bigger option name, quantity and price. the cart view sets the size in px from
    // its own deep selector, so the override has to carry the same depth to win over it
    .kiosk-mode .app > .cart > .itemlist > .item .subs > .group > .entries > .item {
        font-size: 16px * variables.$kioskScale;
        line-height: 26px * variables.$kioskScale;

        // the price column is sized for the smaller text
        > .head > .price {
            flex: 0 0 (72px * variables.$kioskScale);
        }
    }
</style>
